import { createSelector } from "@reduxjs/toolkit";

type PieData = { chartData: { value: number; color: string }[]; totalCount: number };
export const selectMiniPieBackground = createSelector(
  [(data: PieData) => data],
  ({ chartData, totalCount }) => {
    let angle = 0;
    const stops = chartData
      .filter((d) => d.value > 0)
      .map((d) => {
        const start = angle;
        angle += totalCount > 0 ? (d.value / totalCount) * 360 : 0;
        return `${d.color} ${start}deg ${angle}deg`;
      });
    return stops.length ? `conic-gradient(${stops.join(",")})` : "#dce2e8";
  }
);

type TrendData = {
  chartData: Array<Record<string, unknown>>;
  seriesKeys: string[];
  colorByKey: Map<string, string>;
};
export const selectMiniTrendShapes = createSelector(
  [(data: TrendData) => data],
  ({ chartData, seriesKeys, colorByKey }) => {
    if (!chartData.length) return [];
    const totals = chartData.map((row) =>
      seriesKeys.reduce((sum, key) => sum + Number(row[key] ?? 0), 0)
    );
    const maximum = Math.max(1, ...totals);
    const cumulative = chartData.map(() => 0);
    const x = (index: number) =>
      chartData.length === 1 ? 40 : (index * 80) / (chartData.length - 1);
    const y = (value: number) => 30 - (value / maximum) * 30;
    return seriesKeys.map((key) => {
      const lower = cumulative.map((value, i) => `${x(i)},${y(value)}`);
      const upper = chartData.map((row, i) => {
        cumulative[i] += Number(row[key] ?? 0);
        return `${x(i)},${y(cumulative[i])}`;
      });
      return {
        key,
        fill: colorByKey.get(key),
        single: chartData.length === 1,
        y: y(cumulative[0]),
        height: (Number(chartData[0][key] ?? 0) / maximum) * 30,
        points: [...lower, ...upper.reverse()].join(" "),
      };
    });
  }
);
